import type { App as VueApp, Plugin } from "vue";

import AccountLogin from "@Scripts/Components/Account/AccountLogin.vue";
import AccountLogout from "@Scripts/Components/Account/AccountLogout.vue";
import AccountEdit from "@Scripts/Components/Account/AccountEdit.vue";
import AccountRegister from "@Scripts/Components/Account/AccountRegister.vue";
import AccountProfileEdit from "@Scripts/Components/Account/AccountProfileEdit.vue";
import AccountPasswordRemind from "@Scripts/Components/Account/AccountPasswordRemind.vue";
import AccountPasswordReset from "@Scripts/Components/Account/AccountPasswordReset.vue";

import CookieToast from "@Scripts/Components/CookieToast/CookieToast.vue";

import InfoRequest from "@Scripts/Components/InfoRequest/InfoRequest.vue";

import ProductDetailAdd from "@Scripts/Components/Catalogue/ProductDetailAdd.vue";
import CartPreview from "@Scripts/Components/Cart/CartPreview.vue";
import CartDetail from "@Scripts/Components/Cart/CartDetail.vue";
import ShippingCostsPreview from "@Scripts/Components/Cart/ShippingCostsPreview.vue";

import CheckoutSummary from "@Scripts/Components/Checkout/CheckoutSummary.vue";
import CheckoutProfileEdit from "@Scripts/Components/Checkout/CheckoutProfileEdit.vue";

import SearchBox from "@Scripts/Components/Search/SearchBox.vue";

const AppConfig: Plugin = {
    install(app: VueApp) {
        app.component("app-accountlogin", AccountLogin);
        app.component("app-accountlogout", AccountLogout);
        app.component("app-accountedit", AccountEdit);
        app.component("app-accountregister", AccountRegister);
        app.component("app-profileedit", AccountProfileEdit);
        app.component("app-passwordremind", AccountPasswordRemind);
        app.component("app-passwordreset", AccountPasswordReset);

        app.component("app-checkoutprofileedit", CheckoutProfileEdit);

        app.component("app-cookietoast", CookieToast);
        
        app.component("app-inforequest", InfoRequest);

        app.component("product-detail-add", ProductDetailAdd);
        app.component("cart-preview", CartPreview);
        app.component("cart-detail", CartDetail);
        app.component("search-box", SearchBox);
        app.component("shippingcosts-preview", ShippingCostsPreview);
        app.component("checkout-summary", CheckoutSummary);
    }
};

export default AppConfig;